import type { RouteObject } from 'react-router-dom';
import ClientPage from '@/pages/connectra/ClientPage';
import CommunicationsPage from '@/pages/connectra/CommunicationsPage';
import ConnectraDashboard from '@/pages/connectra/ConnectraDashboard';
import { Routes } from '@/routes/routes';

export const connectraRoutes: RouteObject[] = [
	{ path: Routes.CONNECTRA_ROOT, element: <ConnectraDashboard /> },
	{ path: Routes.CONNECTRA_DASHBOARD, element: <ConnectraDashboard /> },
	{ path: Routes.CONNECTRA_CONNECTIONS, element: <CommunicationsPage /> },
	{ path: Routes.CONNECTRA_COMMUNICATIONS, element: <CommunicationsPage /> },
	{ path: Routes.CONNECTRA_CLIENT, element: <ClientPage /> },
];
